import {
  TASKCATEGORY_LOADING,
  GET_TASKCATEGORY,
  GET_TASKCATEGORY_SUCCESS,
  GET_TASKCATEGORY_FAIL,
  ADD_TASKCATEGORY_SUCCESS,
  ADD_TASKCATEGORY_FAIL,
  DELETE_TASKCATEGORY_SUCCESS,
  DELETE_TASKCATEGORY_FAIL,
  UPDATE_TASKCATEGORY_SUCCESS,
  UPDATE_TASKCATEGORY_FAIL,
  TASKCATEGORY_RESET,
} from "./actionType";

const INIT_STATE = {
  taskCategories: [],
  error: {},
};

const TaskCategory = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_TASKCATEGORY_SUCCESS:
      switch (action.payload.actionType) {
        case GET_TASKCATEGORY:
          return {
            ...state,
            taskCategories: action.payload.data,
            isTaskCategoryCreated: false,
            isTaskCategorySuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_TASKCATEGORY_FAIL:
      switch (action.payload.actionType) {
        case GET_TASKCATEGORY_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isTaskCategoryCreated: false,
            isTaskCategorySuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_TASKCATEGORY: {
      return {
        ...state,
        isTaskCategoryCreated: false,
        loading: true,
      };
    }

    case TASKCATEGORY_LOADING: {
      return {
        ...state,
        isTaskCategoryCreated: false,
        loading: true,
      };
    }

    case ADD_TASKCATEGORY_SUCCESS:
      return {
        ...state,
        isTaskCategoryCreated: true,
        loading: false,
        taskCategories: [action.payload.data, ...state.taskCategories],
      };

    case ADD_TASKCATEGORY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_TASKCATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        taskCategories: state.taskCategories.filter(
          (taskCategory) => taskCategory.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_TASKCATEGORY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_TASKCATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        taskCategories: state.taskCategories.map((taskCategory) =>
          taskCategory.id.toString() === action.payload.data.id.toString()
            ? { ...taskCategory, ...action.payload.data }
            : taskCategory
        ),
      };

    case UPDATE_TASKCATEGORY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case TASKCATEGORY_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default TaskCategory;
